export { default } from './ParticipantEditModal'



// WEBPACK FOOTER //
// ./src/App/components/ParticipantEditModal/index.js